let lingua = {
    'homelidays_es': {
        consolidationBannerDesc: 'Dentro de poco, Homelidays pasará a ser HomeAway. Tendrás a tu disposición una increíble selección de casas de vacaciones… ¡con el mismo proceso de reserva de siempre! Entra en HomeAway hoy mismo y encuentra la casa ideal para tus próximas vacaciones. ',
        moreInfoPreAnchorText: '¿Quieres saber más? Si eres un viajero, te lo contamos ',
        moreInfoAnchorText: 'aquí',
        moreInfoHref: 'https://homelidays.es/lp/lanuevacasadehomelidays-viajeros',
        moreInfoPostAnchorText: '. ',

        moreInfo2PreAnchorText: 'Y si eres un propietario, ',
        moreInfo2AnchorText: 'aquí',
        moreInfo2Href: 'https://homelidays.es/lp/lanuevacasadehomelidays-propietarios',
        moreInfo2PostAnchorText: '.'
    },
    'homeaway_es': {
        consolidationBannerDesc: 'Bienvenido/a a HomeAway, ¡la nueva casa de Homelidays! ',
        moreInfoPreAnchorText: '¿Quieres saber más? Si eres un viajero, te lo contamos ',
        moreInfoAnchorText: 'aquí',
        moreInfoHref: 'https://homeaway.es/lp/lanuevacasadehomelidays-viajeros',
        moreInfoPostAnchorText: '. ',

        moreInfo2PreAnchorText: 'Y si eres un propietario, ',
        moreInfo2AnchorText: 'aquí',
        moreInfo2Href: 'https://homeaway.es/lp/lanuevacasadehomelidays-propietarios',
        moreInfo2PostAnchorText: '.'
    },
    'homelidays_it': {
        consolidationBannerDesc: 'Homelidays diventerà presto HomeAway. Vuoi saperne di più? ',
        moreInfoPreAnchorText: 'Se sei un viaggiatore, ',
        moreInfoAnchorText: 'clicca qui',
        moreInfoHref: 'https://www.homelidays.it/lp/lanuovacasadihomelidays-viaggiatori/',
        moreInfoPostAnchorText: '. ',

        moreInfo2PreAnchorText: 'Se invece sei un proprietario, ',
        moreInfo2AnchorText: 'dai un\'occhiata qui.',
        moreInfo2Href: 'https://www.homelidays.it/lp/lanuovacasadihomelidays-proprietari/',
        moreInfo2PostAnchorText: '.'
    },
    'homeaway_it': {
        consolidationBannerDesc: 'HomeAway, la nuova casa di Homelidays, ti dà il benvenuto! Vuoi sapere perché cambiamo? ',
        moreInfoPreAnchorText: 'Se sei un viaggiatore, ',
        moreInfoAnchorText: 'clicca qui',
        moreInfoHref: 'https://www.homeaway.it/lp/lanuovacasadihomelidays-viaggiatori/',
        moreInfoPostAnchorText: '. ',

        moreInfo2PreAnchorText: 'Se invece sei un proprietario, ',
        moreInfo2AnchorText: 'dai un\'occhiata qui',
        moreInfo2Href: 'https://www.homeaway.it/lp/lanuovacasadihomelidays-proprietari/',
        moreInfo2PostAnchorText: '.'
    },
    'odhr': {
        consolidationBannerDesc: 'Owners Direct is moving to HomeAway. Expect the same great experience and access to an international selection of holiday homes. ',
        moreInfoPreAnchorText: 'Want to know more? Holidaymakers, ',
        moreInfoAnchorText: 'click here',
        moreInfoHref: 'https://www.ownersdirect.co.uk/lp/new-home-traveller',
        moreInfoPostAnchorText: '. ',

        moreInfo2PreAnchorText: 'Or, if you\'re one of our partners, ',
        moreInfo2AnchorText: 'click here',
        moreInfo2Href: 'https://www.ownersdirect.co.uk/lp/thenewhomeofownersdirect-owner',
        moreInfo2PostAnchorText: '.'
    },
    'homeaway_uk': {
        consolidationBannerDesc: 'Welcome to HomeAway, the new home of Owners Direct! From villas to cottages, find homes that match you. ',
        moreInfoPreAnchorText: 'Want to know more? Holidaymakers, ',
        moreInfoAnchorText: 'click here',
        moreInfoHref: 'https://www.homeaway.co.uk/lp/new-home-traveller',
        moreInfoPostAnchorText: '. ',

        moreInfo2PreAnchorText: 'Or, if you\'re one of our partners, ',
        moreInfo2AnchorText: 'click here',
        moreInfo2Href: 'https://www.homeaway.co.uk/lp/newhome',
        moreInfo2PostAnchorText: '.'
    }
};
export default lingua;